module.exports = __webpack_public_path__ + "img/vlive_logo.9226d9bf.png";